<div class="result-container">
  @if (searchInProgress) {
    <div class="spinner">
      <spinner [spinnerSize]="30"></spinner>
    </div>
  } @else {
    @if (!compact && searchResults && searchResults?.searchResults.length > 10) {
      <div class="result-label">
        <div class="heading-s">{{ resultsLabel }}</div>
      </div>
    }

    @if (resultListEmpty) {
      <eop-quick-access-entry
        [compact]="compact"
        [disabled]="true"
        [entry]="{
          label: 'GLOBAL.RESULTS_NONE' | translate,
          icon: 'eoperate-ic-search',
        }"></eop-quick-access-entry>
    }

    <div class="result-entries-container">
      @if (chargingStationsResults?.length > 0) {
        <div class="result-label-small">
          <div class="label-s">{{ 'GLOBAL.CHARGING_STATIONS' | translate | uppercase }}</div>
        </div>

        <eop-quick-access-entry
          *ngFor="let chargingStation of chargingStationsResults | slice: 0 : 10"
          [compact]="compact"
          [entry]="{
            label: chargingStation.value,
            icon: 'ic-charging-station',
            tooltip: 'GLOBAL.CHARGING_STATION_ID' | translate,
          }"
          [additionalEntries]="[
            {
              label: chargingStation.ocppChargeboxId ?? chargingStation.serialNumber,
              icon: 'station-ocpp-chargebox-id',
              tooltip: chargingStation.ocppChargeboxId
                ? ('CHARGING_STATION.OCPP_CONTROLLER_ID' | translate)
                : ('CHARGING_STATION.SERIAL_NUMBER' | translate),
            },
          ]"
          [isSelected]="chargingStation.value === selectedResult?.value"
          [highlightedColor]="
            chargingStation.installationStatus === ChargingStationState.PLANNED
              ? HighLightedColor.INFO
              : chargingStation.installationStatus === ChargingStationState.ABET
                ? HighLightedColor.WARNING
                : HighLightedColor.NONE
          "
          (click)="onResultClicked(chargingStation)"
          (mouseover)="selectedResult = chargingStation"></eop-quick-access-entry>
      }

      @if (chargePointsResults?.length > 0) {
        <div class="result-label-small">
          <div class="label-s">{{ 'GLOBAL.CHARGE_POINTS' | translate | uppercase }}</div>
        </div>

        <eop-quick-access-entry
          *ngFor="let chargePoint of chargePointsResults | slice: 0 : 10"
          [compact]="compact"
          [entry]="{
            label: chargePoint.value,
            icon: 'charge-port-outlined',
            tooltip: 'GLOBAL.CHARGE_POINT_ID' | translate,
          }"
          [additionalEntries]="[
            {
              label: chargePoint.ocppChargeboxId ?? chargePoint.serialNumber,
              icon: 'station-ocpp-chargebox-id',
              tooltip: chargePoint.ocppChargeboxId
                ? ('CHARGING_STATION.OCPP_CONTROLLER_ID' | translate)
                : ('CHARGING_STATION.SERIAL_NUMBER' | translate),
            },
            {
              label: chargePoint.stationName,
              icon: 'ic-charging-station',
              tooltip: 'GLOBAL.CHARGING_STATION' | translate,
            },
          ]"
          [isSelected]="chargePoint.value === selectedResult?.value"
          [highlightedColor]="
            chargePoint.installationStatus === ChargingStationState.PLANNED
              ? HighLightedColor.INFO
              : chargePoint.installationStatus === ChargingStationState.ABET
                ? HighLightedColor.WARNING
                : HighLightedColor.NONE
          "
          (click)="onResultClicked(chargePoint)"
          (mouseover)="selectedResult = chargePoint"></eop-quick-access-entry>
      }
    </div>
  }
</div>
